import { COMPLIANCE_LEAGLE,SET_UNAUTHENTICATED,COMPLIANCE_DOCUMENT,COMPLIANCE_FILE_DATA,COMPLIANCE_SELECT } from '../type';


    const initialState = {
       complianceLeagleData:[],
       complianceDocumentData:[],
       complianceFileData:[],
       complianceSelectData:[],
    }

    export default function (state = initialState, action) {
        switch (action.type) {
            case SET_UNAUTHENTICATED:
                return initialState;
               
                    case COMPLIANCE_LEAGLE:
                        return {
                            ...state,
                            complianceLeagleData: action.payload,
                            loading: false
                        } 
                    case COMPLIANCE_DOCUMENT:
                    return {
                        ...state,
                        complianceDocumentData: action.payload,
                        loading: false
                    } 
                     case COMPLIANCE_FILE_DATA:
                    return {
                        ...state,
                        complianceFileData: action.payload,
                        loading: false
                    } 
                     case COMPLIANCE_SELECT:
                    return {
                        ...state,
                        complianceSelectData: action.payload,
                        loading: false
                    } 
                    default: 
                    return state;
        }
    
    
    }